import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { useState } from 'react';
import { FlaskConical } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { AutoplayABTestConfig, AutoplayVariation } from '@/store/videoFeatures/types';
import { FinalizeAutoplayTestModal } from '../FinalizeAutoplayTestModal';
import { ABTestDetailsInline } from './ABTestDetailsInline';

interface ActiveTestPanelProps {
  testConfig: AutoplayABTestConfig;
  variations: AutoplayVariation[];
  onFinalize: () => void;
  onViewMetrics?: () => void;
  videoId?: string;
  videoWidth?: number;
  videoHeight?: number;
}

export const ActiveTestPanel: React.FC<ActiveTestPanelProps> = ({
  testConfig,
  variations,
  onFinalize,
  onViewMetrics,
  videoId,
  videoWidth,
  videoHeight
}) => {
  useLanguage();
  const [showFinalizeModal, setShowFinalizeModal] = useState(false);

  const testName = `Teste com ${variations.length} variações`;

  const handleFinalizeConfirm = () => {
    onFinalize();
    setShowFinalizeModal(false);
  };

  return (
    <div className="flex flex-col h-full py-4">
      {/* Card: Testes em Andamento */}
      <div className="rounded-xl border border-border bg-background p-4">
        {/* Badge Testes em andamento - Azul */}
        <div className="flex items-center gap-2 mb-4">
          <Badge className="bg-primary/10 text-primary border border-primary/20 gap-1.5 font-medium text-xs px-2.5 py-1 hover:bg-primary/15">
            <FlaskConical className="h-3.5 w-3.5" />
            {translateInterfaceText("Testes em andamento")}</Badge>
        </div>
        
        {/* Detalhes do teste - sempre visíveis */}
        <ABTestDetailsInline
          testConfig={testConfig}
          variations={variations}
          onViewMetrics={onViewMetrics}
          onFinalize={() => setShowFinalizeModal(true)}
          videoId={videoId}
          videoWidth={videoWidth}
          videoHeight={videoHeight}
        />
      </div>

      {/* Modal de Finalização */}
      <FinalizeAutoplayTestModal
        isOpen={showFinalizeModal}
        onOpenChange={setShowFinalizeModal}
        onConfirm={handleFinalizeConfirm}
        testId={testConfig.testId}
      />
    </div>
  );
};